module.exports = __webpack_public_path__ + "static/media/loadingblue.bdb912a0.svg";